import PropTypes from 'prop-types'

const Banners = (props) => {
  return (
    <>
      <div id="contenedorBannerTiendasOficiales">
        <img className="logo" src={props.logoPath} alt={1} />
      </div>
    </>
  )
}

Banners.propTypes = {
  logoPath: PropTypes.string.isRequired
}

export default Banners
